/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Bypass_Dialogue_LabelInputs */

const en_ad_bypass_dialogue_label = /** @type {(inputs: Ad_Bypass_Dialogue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypass dialogue`)
};

const fr_ad_bypass_dialogue_label = /** @type {(inputs: Ad_Bypass_Dialogue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contourner le dialogue`)
};

const de_ad_bypass_dialogue_label = /** @type {(inputs: Ad_Bypass_Dialogue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialog überspringen`)
};

const it_ad_bypass_dialogue_label = /** @type {(inputs: Ad_Bypass_Dialogue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bypassare il dialogo`)
};

const ru_ad_bypass_dialogue_label = /** @type {(inputs: Ad_Bypass_Dialogue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обход диалога`)
};

const es_ad_bypass_dialogue_label = /** @type {(inputs: Ad_Bypass_Dialogue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo de omisión`)
};

const zh_cn2_ad_bypass_dialogue_label = /** @type {(inputs: Ad_Bypass_Dialogue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绕过对话框`)
};

const ja_ad_bypass_dialogue_label = /** @type {(inputs: Ad_Bypass_Dialogue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダイアログをバイパス`)
};

const hi_ad_bypass_dialogue_label = /** @type {(inputs: Ad_Bypass_Dialogue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाईपास संवाद`)
};

const pt_pt2_ad_bypass_dialogue_label = /** @type {(inputs: Ad_Bypass_Dialogue_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ignorar diálogo`)
};

/**
* | output |
* | --- |
* | "Bypass dialogue" |
*
* @param {Ad_Bypass_Dialogue_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_bypass_dialogue_label = /** @type {((inputs?: Ad_Bypass_Dialogue_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Bypass_Dialogue_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_bypass_dialogue_label(inputs)
	if (locale === "de") return de_ad_bypass_dialogue_label(inputs)
	if (locale === "it") return it_ad_bypass_dialogue_label(inputs)
	if (locale === "ru") return ru_ad_bypass_dialogue_label(inputs)
	if (locale === "es") return es_ad_bypass_dialogue_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_bypass_dialogue_label(inputs)
	if (locale === "ja") return ja_ad_bypass_dialogue_label(inputs)
	if (locale === "hi") return hi_ad_bypass_dialogue_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_bypass_dialogue_label(inputs)
	return en_ad_bypass_dialogue_label(inputs)
});